/*
 * Keyboard and screen reader support for the product media gallery.
 * Horizon's slideshow ships arrows and thumbnails but no arrow-key navigation
 * and no "Image 3 of 8" announcement, so this adds both on top of its own API.
 */
class ZaProductGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.slideshow = gallery.querySelector('slideshow-component');
    if (!this.slideshow) return;

    this.thumbs = [...gallery.querySelectorAll('.slideshow-controls__thumbnail')];
    this.total = this.thumbs.length || gallery.querySelectorAll('slideshow-slide').length;
    if (this.total < 2) return;

    this.slideshow.setAttribute('tabindex', '0');
    this.slideshow.setAttribute('role', 'group');
    this.slideshow.setAttribute('aria-roledescription', 'carousel');
    if (!this.slideshow.hasAttribute('aria-label')) this.slideshow.setAttribute('aria-label', 'Product images');

    this.status = document.createElement('p');
    this.status.className = 'visually-hidden';
    this.status.setAttribute('aria-live', 'polite');
    gallery.append(this.status);

    this.gallery.addEventListener('keydown', this.onKeydown);

    if (this.thumbs.length) {
      this.observer = new MutationObserver(() => this.announce());
      for (const thumb of this.thumbs) this.observer.observe(thumb, { attributes: true, attributeFilter: ['aria-selected'] });
    }
  }

  onKeydown = (event) => {
    if (event.target.closest('input, textarea, select')) return;
    if (event.key === 'ArrowRight') {
      this.slideshow.next();
      event.preventDefault();
    } else if (event.key === 'ArrowLeft') {
      this.slideshow.previous();
      event.preventDefault();
    }
  };

  announce() {
    const index = this.thumbs.findIndex((thumb) => thumb.getAttribute('aria-selected') === 'true');
    if (index < 0) return;
    const text = `Image ${index + 1} of ${this.total}`;
    if (this.status.textContent !== text) this.status.textContent = text;
  }
}

const setup = () => {
  for (const gallery of document.querySelectorAll('media-gallery')) {
    if (gallery.dataset.zaGallery || gallery.closest('dialog')) continue;
    gallery.dataset.zaGallery = 'true';
    new ZaProductGallery(gallery);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setup);
} else {
  setup();
}

document.addEventListener('shopify:section:load', setup);
